import { apiDaInscricao } from './axios';
import IMoradia from '../interfaces/IMoradia';

export const salvarMoradia = async (moradia: IMoradia, idInscricao: Number) => {

  const payload = { ...moradia, idInscricao };
  await apiDaInscricao().post(`/moradia/${idInscricao}`, payload);
};